module.exports = __webpack_public_path__ + "static/media/bg_banner.e8a604f6.jpg";